const AWESOME_QUOTES = [
    "Beware of low-flying butterflies.",
    "Nothing so needs reforming as other people's habits.",
    "Excellent time to become a missing person.",
    "I love deadlines. I love the whooshing sound they make as they fly by.",
    "Do something unusual today. Pay a bill.",
]
const FAMOUS_QUOTES = [
    "Yes there is a lot of people doing a great job out there.",
    "If your life was a horse, you'd have to shoot it.",
    "A classic is something that everyone wants to have read and nobody wants to read.",
    "You have taken yourself too seriously.",
    "It's not a bug - it's an undocumented feature.",
]

const POSSIBLE_QUOTE_TYPES = ["Awesome", "Famous"]

const randomBetween = (min, max) => {
    return min + Math.floor(Math.random() * (max - min + 1))
}

const generateQuotes = (numQuotes, type) => {
    const quotes = []
    let quote_list = ""
    if (type == "Awesome") {
        quote_list = [...AWESOME_QUOTES]
    } else {
        quote_list = [...FAMOUS_QUOTES]
    }
    for (let i = 0; i < numQuotes; ++i) {
        const index = randomBetween(0, quote_list.length - 1)
        quotes.push({
            quote: quote_list[index],
            score: randomBetween(1, 100)
        })
        quote_list.splice(index, 1)
    }
    return quotes;
}

const initialState = () => {
    const NUM_QUOTES = 5;

    const quoteTypes = []
    const possibleQuoteTypesCopy = [...POSSIBLE_QUOTE_TYPES]

    while (possibleQuoteTypesCopy.length !== 0) {
        const index = randomBetween(0, possibleQuoteTypesCopy.length - 1)
        quoteTypes.push(possibleQuoteTypesCopy[index])
        possibleQuoteTypesCopy.splice(index, 1)
    }

    const quotes = quoteTypes.map((quoteType) => ({
        type: quoteType,
        quotes: generateQuotes(NUM_QUOTES, quoteType),
    }))
    return {
        quotes
    }
}

export const quoteReducer = (state = initialState()) => state;
